/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { VScheduledAppointment } from '../../models/v-scheduled-appointment';

export interface GetSchedulesAppointments$Json$Params {
}

export function getSchedulesAppointments$Json(http: HttpClient, rootUrl: string, params?: GetSchedulesAppointments$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<VScheduledAppointment>>> {
  const rb = new RequestBuilder(rootUrl, getSchedulesAppointments$Json.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<VScheduledAppointment>>;
    })
  );
}

getSchedulesAppointments$Json.PATH = '/Schedule';
